import * as amplitude from '@amplitude/analytics-browser';
import { storageHelper, User } from '@spo/logic';
import { useEffect } from 'react';

export const useAmplitudeLogMember = () => {
  const user = storageHelper.getItem<User>('user');

  useEffect(() => {
    if (user) {
      amplitude.logEvent('Member user', {
        user_id: user.uid,
        job: user.job,
        email: user.mail,
      });
    }
  }, [user?.uid]);
};
